import { gql } from '@apollo/client';

export const USER = gql`
    query Me {
      me {
        id
        email
        userName
        firstName
        lastName
        phone
        vacationStartAt
        vacationEndAt
        vacationIsActive
        currentVacationSessionId
      }
    }
`;

export const USER_SAVINGS = gql`
  query SavingsWithPrimePostRx {
    savingsWithPrimePostRx
  }
`;

export const FREE_PRIORITY_SHIPPING_REMAINING = gql`
  query FreePriorityShippingRemaining {
    freePriorityShippingRemaining
  }
`;

export const REGISTER_USER = gql`
  mutation RegisterUser($data: RegisterUserInput!) {
    registerUser(data: $data) {
      createdAt
      email
      firstName
      id
      lastName
      pharmacyId
      phone
      updatedAt
      userName
    }
  }
`;

export const USER_BY_ID = gql`
   query FindUniqueUser($where: UserWhereUniqueInput!) {
    findUniqueUser(where: $where) {
      id
      email
      firstName
      lastName
      phone
    }
  }
`;

export const UPDATE_USER = gql`
   mutation UpdateUser($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
    updateUser(data: $data, where: $where) {
      id
      email
    }
  }
`;

export const DELETE_USER = gql`
   mutation DeleteUser($where: UserWhereUniqueInput!) {
    deleteUser(where: $where) {
      id
    }
  }
`;

export const SET_VACATION_MODE = gql`
  mutation SetVacationMode($data: SetVacationModeInput!) {
    setVacationMode(data: $data) {
      id
      userId
      startAt
      endAt
      status
      activatedAt
      endedAt
      endedByUserId
    }
  }
`;

export const END_VACATION_MODE = gql`
  mutation EndVacationMode($data: EndVacationModeInput) {
    endVacationMode(data: $data) {
      id
      userId
      startAt
      endAt
      status
      activatedAt
      endedAt
      endedByUserId
    }
  }
`;

export const MY_VACATION_HISTORY = gql`
  query MyVacationHistory {
    myVacationHistory {
      id
      userId
      startAt
      endAt
      status
      activatedAt
      endedAt
      endedByUserId
      createdAt
      updatedAt
    }
  }
`;
